let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fIRSs")).then(() => parcelRequire('1Wr4X'));